/**
 * The option lists the forms share: countries, dialling codes, experience bands,
 * job types and the position list the Hirevly test mapping keys off.
 *
 * Lived under pages/ApplyQAEngineer/constants.ts, but four files import them --
 * including the admin panel, which is not a page of that form. Reference data
 * belongs beside the other content, not inside one of its consumers.
 */
export type CountryRegion = 'Africa' | 'Americas' | 'Asia' | 'Europe' | 'Oceania';

export interface Country {
  code: string;
  name: string;
  flag: string;
  region: CountryRegion;
}

export const countries: readonly Country[] = [
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', region: 'Asia' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱', region: 'Europe' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿', region: 'Africa' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', region: 'Americas' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲', region: 'Asia' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', region: 'Oceania' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', region: 'Europe' },
  { code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿', region: 'Asia' },
  { code: 'BH', name: 'Bahrain', flag: '🇧🇭', region: 'Asia' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', region: 'Asia' },
  { code: 'BY', name: 'Belarus', flag: '🇧🇾', region: 'Europe' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', region: 'Europe' },
  { code: 'BA', name: 'Bosnia and Herzegovina', flag: '🇧🇦', region: 'Europe' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', region: 'Americas' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬', region: 'Europe' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', region: 'Americas' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', region: 'Americas' },
  { code: 'CN', name: 'China', flag: '🇨🇳', region: 'Asia' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', region: 'Americas' },
  { code: 'HR', name: 'Croatia', flag: '🇭🇷', region: 'Europe' },
  { code: 'CY', name: 'Cyprus', flag: '🇨🇾', region: 'Asia' },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', region: 'Europe' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', region: 'Europe' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', region: 'Africa' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪', region: 'Europe' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', region: 'Europe' },
  { code: 'FR', name: 'France', flag: '🇫🇷', region: 'Europe' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪', region: 'Asia' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', region: 'Europe' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', region: 'Africa' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', region: 'Europe' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', region: 'Europe' },
  { code: 'IS', name: 'Iceland', flag: '🇮🇸', region: 'Europe' },
  { code: 'IN', name: 'India', flag: '🇮🇳', region: 'Asia' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', region: 'Asia' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷', region: 'Asia' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶', region: 'Asia' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', region: 'Europe' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', region: 'Asia' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', region: 'Europe' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', region: 'Asia' },
  { code: 'JO', name: 'Jordan', flag: '🇯🇴', region: 'Asia' },
  { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿', region: 'Asia' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', region: 'Africa' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼', region: 'Asia' },
  { code: 'LV', name: 'Latvia', flag: '🇱🇻', region: 'Europe' },
  { code: 'LB', name: 'Lebanon', flag: '🇱🇧', region: 'Asia' },
  { code: 'LT', name: 'Lithuania', flag: '🇱🇹', region: 'Europe' },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', region: 'Europe' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', region: 'Asia' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', region: 'Europe' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', region: 'Americas' },
  { code: 'MD', name: 'Moldova', flag: '🇲🇩', region: 'Europe' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪', region: 'Europe' },
  { code: 'MA', name: 'Morocco', flag: '🇲🇦', region: 'Africa' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', region: 'Europe' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', region: 'Oceania' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', region: 'Africa' },
  { code: 'MK', name: 'North Macedonia', flag: '🇲🇰', region: 'Europe' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', region: 'Europe' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', region: 'Asia' },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', region: 'Americas' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', region: 'Asia' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', region: 'Europe' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', region: 'Europe' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', region: 'Asia' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴', region: 'Europe' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', region: 'Asia' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸', region: 'Europe' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', region: 'Asia' },
  { code: 'SK', name: 'Slovakia', flag: '🇸🇰', region: 'Europe' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮', region: 'Europe' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', region: 'Africa' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', region: 'Asia' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', region: 'Europe' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', region: 'Europe' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', region: 'Europe' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', region: 'Asia' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', region: 'Asia' },
  { code: 'UA', name: 'Ukraine', flag: '🇺🇦', region: 'Europe' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', region: 'Asia' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', region: 'Europe' },
  { code: 'US', name: 'United States', flag: '🇺🇸', region: 'Americas' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', region: 'Americas' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', region: 'Americas' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', region: 'Asia' },
];

/**
 * The regions the admin lists group candidates by, in UN M49 terms.
 *
 * M49 rather than a looser "everyone would say Turkey is European" grouping,
 * because the alternative is a per-country argument with no answer: Cyprus,
 * Georgia, Armenia and Azerbaijan all sit on the same seam. One published
 * standard means the chips can be explained rather than defended.
 *
 * The region lives on the country entry above rather than in a second list, so
 * a country cannot be added without being placed -- the type demands it.
 */
export const countryRegions: readonly CountryRegion[] = [
  'Europe',
  'Americas',
  'Asia',
  'Africa',
  'Oceania',
];

/**
 * The ISO-2 codes a set of regions covers.
 *
 * The chips resolve to codes here, in the browser, and send those to the API.
 * The alternative -- sending the region name and mapping it server-side -- would
 * put the same table in the Deno bundle, where nothing checks it against this
 * one. Sending codes keeps the mapping in exactly one place.
 */
export function countryCodesInRegions(regions: readonly CountryRegion[]): string[] {
  const wanted = new Set(regions);
  return countries.filter((country) => wanted.has(country.region)).map((country) => country.code);
}

export const countryCodes = [
  { id: 'cc_al', code: '+355', name: 'Albania', country: 'Albania', flag: '🇦🇱' },
  { id: 'cc_au', code: '+61', name: 'Australia', country: 'Australia', flag: '🇦🇺' },
  { id: 'cc_at', code: '+43', name: 'Austria', country: 'Austria', flag: '🇦🇹' },
  { id: 'cc_by', code: '+375', name: 'Belarus', country: 'Belarus', flag: '🇧🇾' },
  { id: 'cc_be', code: '+32', name: 'Belgium', country: 'Belgium', flag: '🇧🇪' },
  { id: 'cc_ba', code: '+387', name: 'Bosnia and Herzegovina', country: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { id: 'cc_br', code: '+55', name: 'Brazil', country: 'Brazil', flag: '🇧🇷' },
  { id: 'cc_bg', code: '+359', name: 'Bulgaria', country: 'Bulgaria', flag: '🇧🇬' },
  { id: 'cc_ca', code: '+1', name: 'Canada', country: 'Canada', flag: '🇨🇦' },
  { id: 'cc_cn', code: '+86', name: 'China', country: 'China', flag: '🇨🇳' },
  { id: 'cc_hr', code: '+385', name: 'Croatia', country: 'Croatia', flag: '🇭🇷' },
  { id: 'cc_cy', code: '+357', name: 'Cyprus', country: 'Cyprus', flag: '🇨🇾' },
  { id: 'cc_cz', code: '+420', name: 'Czech Republic', country: 'Czech Republic', flag: '🇨🇿' },
  { id: 'cc_dk', code: '+45', name: 'Denmark', country: 'Denmark', flag: '🇩🇰' },
  { id: 'cc_ee', code: '+372', name: 'Estonia', country: 'Estonia', flag: '🇪🇪' },
  { id: 'cc_fi', code: '+358', name: 'Finland', country: 'Finland', flag: '🇫🇮' },
  { id: 'cc_fr', code: '+33', name: 'France', country: 'France', flag: '🇫🇷' },
  { id: 'cc_ge', code: '+995', name: 'Georgia', country: 'Georgia', flag: '🇬🇪' },
  { id: 'cc_de', code: '+49', name: 'Germany', country: 'Germany', flag: '🇩🇪' },
  { id: 'cc_gr', code: '+30', name: 'Greece', country: 'Greece', flag: '🇬🇷' },
  { id: 'cc_hu', code: '+36', name: 'Hungary', country: 'Hungary', flag: '🇭🇺' },
  { id: 'cc_is', code: '+354', name: 'Iceland', country: 'Iceland', flag: '🇮🇸' },
  { id: 'cc_in', code: '+91', name: 'India', country: 'India', flag: '🇮🇳' },
  { id: 'cc_ie', code: '+353', name: 'Ireland', country: 'Ireland', flag: '🇮🇪' },
  { id: 'cc_il', code: '+972', name: 'Israel', country: 'Israel', flag: '🇮🇱' },
  { id: 'cc_it', code: '+39', name: 'Italy', country: 'Italy', flag: '🇮🇹' },
  { id: 'cc_jp', code: '+81', name: 'Japan', country: 'Japan', flag: '🇯🇵' },
  { id: 'cc_lv', code: '+371', name: 'Latvia', country: 'Latvia', flag: '🇱🇻' },
  { id: 'cc_lt', code: '+370', name: 'Lithuania', country: 'Lithuania', flag: '🇱🇹' },
  { id: 'cc_lu', code: '+352', name: 'Luxembourg', country: 'Luxembourg', flag: '🇱🇺' },
  { id: 'cc_my', code: '+60', name: 'Malaysia', country: 'Malaysia', flag: '🇲🇾' },
  { id: 'cc_mt', code: '+356', name: 'Malta', country: 'Malta', flag: '🇲🇹' },
  { id: 'cc_mx', code: '+52', name: 'Mexico', country: 'Mexico', flag: '🇲🇽' },
  { id: 'cc_md', code: '+373', name: 'Moldova', country: 'Moldova', flag: '🇲🇩' },
  { id: 'cc_me', code: '+382', name: 'Montenegro', country: 'Montenegro', flag: '🇲🇪' },
  { id: 'cc_nl', code: '+31', name: 'Netherlands', country: 'Netherlands', flag: '🇳🇱' },
  { id: 'cc_nz', code: '+64', name: 'New Zealand', country: 'New Zealand', flag: '🇳🇿' },
  { id: 'cc_mk', code: '+389', name: 'North Macedonia', country: 'North Macedonia', flag: '🇲🇰' },
  { id: 'cc_no', code: '+47', name: 'Norway', country: 'Norway', flag: '🇳🇴' },
  { id: 'cc_pl', code: '+48', name: 'Poland', country: 'Poland', flag: '🇵🇱' },
  { id: 'cc_pt', code: '+351', name: 'Portugal', country: 'Portugal', flag: '🇵🇹' },
  { id: 'cc_ro', code: '+40', name: 'Romania', country: 'Romania', flag: '🇷🇴' },
  { id: 'cc_rs', code: '+381', name: 'Serbia', country: 'Serbia', flag: '🇷🇸' },
  { id: 'cc_sg', code: '+65', name: 'Singapore', country: 'Singapore', flag: '🇸🇬' },
  { id: 'cc_sk', code: '+421', name: 'Slovakia', country: 'Slovakia', flag: '🇸🇰' },
  { id: 'cc_si', code: '+386', name: 'Slovenia', country: 'Slovenia', flag: '🇸🇮' },
  { id: 'cc_za', code: '+27', name: 'South Africa', country: 'South Africa', flag: '🇿🇦' },
  { id: 'cc_kr', code: '+82', name: 'South Korea', country: 'South Korea', flag: '🇰🇷' },
  { id: 'cc_es', code: '+34', name: 'Spain', country: 'Spain', flag: '🇪🇸' },
  { id: 'cc_se', code: '+46', name: 'Sweden', country: 'Sweden', flag: '🇸🇪' },
  { id: 'cc_ch', code: '+41', name: 'Switzerland', country: 'Switzerland', flag: '🇨🇭' },
  { id: 'cc_th', code: '+66', name: 'Thailand', country: 'Thailand', flag: '🇹🇭' },
  { id: 'cc_tr', code: '+90', name: 'Turkey', country: 'Turkey', flag: '🇹🇷' },
  { id: 'cc_ua', code: '+380', name: 'Ukraine', country: 'Ukraine', flag: '🇺🇦' },
  { id: 'cc_ae', code: '+971', name: 'United Arab Emirates', country: 'United Arab Emirates', flag: '🇦🇪' },
  { id: 'cc_gb', code: '+44', name: 'United Kingdom', country: 'United Kingdom', flag: '🇬🇧' },
  { id: 'cc_us', code: '+1', name: 'United States', country: 'United States', flag: '🇺🇸' },
  { id: 'cc_vn', code: '+84', name: 'Vietnam', country: 'Vietnam', flag: '🇻🇳' },
];

export const yearsOfExperience = [
  '3-4 years',
  '5-6 years', 
  '7-8 years',
  '9-10 years',
  '11+ years'
];

export const jobTypes = [
  'Full time job',
  'Second additional project',
  'I need a consultation about my future cooperation with WeAreQA'
];

export const englishInterviewOptions = [
  'Yes',
  'No',
  'I have doubts and need assistance'
];

export const positions = [
  'Junior Manual QA Engineer',
  'Middle Manual QA Engineer',
  'Senior Manual QA Engineer',
  'Junior AQA Engineer Java',
  'Middle AQA Engineer Java',
  'Senior AQA Engineer Java',
  'Junior AQA Engineer JS/TS',
  'Middle AQA Engineer JS/TS',
  'Senior AQA Engineer JS/TS',
  'Junior AQA Engineer Python',
  'Middle AQA Engineer Python',
  'Senior AQA Engineer Python',
  'Junior AQA Engineer C#',
  'Middle AQA Engineer C#',
  'Senior AQA Engineer C#'
];


/* ------------------------------------------------------------------------- */
/* Employer enquiry                                                          */
/* ------------------------------------------------------------------------- */

export const companySizes = [
  'Startup (1-10 employees)',
  'Small Business (11-50 employees)',
  'Medium Business (51-200 employees)',
  'Large Business (201-1000 employees)',
  'Enterprise (1000+ employees)'
];

export const industries = [
  'Technology/Software',
  'Financial Services/Fintech',
  'Healthcare/Medical',
  'E-commerce/Retail',
  'Education/EdTech',
  'Entertainment/Gaming',
  'Consulting/Professional Services',
  'Manufacturing',
  'AI/ML',
  'Blockchain/Web3/Crypto',
  'Public Institution',
  'Other'
];

export const employmentTypes = [
  'Full-time Employee',
  'Contract/Freelance',
  'Part-time',
  'Temporary/Project-based'
];

export const experienceLevels = [
  'Junior (1-3 years)',
  'Mid-level (3-5 years)',
  'Senior (5-8 years)',
  'Lead/Principal (8+ years)',
  'Management/Director level'
];

export const workArrangements = [
  'Fully Remote',
  'Hybrid (Remote + Office)',
  'On-site Required'
];

export const urgencyOptions = [
  'ASAP (Within 2 weeks)',
  'Soon (Within 1 month)',
  'Standard (1-2 months)',
  'Flexible (2+ months)'
];

export const howDidYouHearOptions = [
  'Google Search',
  'LinkedIn',
  'Referral from colleague',
  'Industry blog/article',
  'Social media',
  'Conference/Event',
  'Other'
];

/**
 * Filter predicate for the dialling-code picker: matches the country name or
 * the code itself, with or without the leading "+", so both "ukr" and "380"
 * find Ukraine.
 */
export function matchesCountryCode(
  countryCode: { name: string; code: string },
  query: string,
): boolean {
  const needle = query.toLowerCase().replace(/^\+/, '');
  return (
    countryCode.name.toLowerCase().includes(needle) ||
    countryCode.code.replace('+', '').includes(needle)
  );
}
